// extracted by mini-css-extract-plugin
export var container = "_g8-1";
export var editor = "_g8-2";
export var resizable = "_g8-3";
export var wrapper = "_g8-0";